module.exports = __webpack_public_path__ + "static/hand-phone-bbb93237ea8b07af0c8f7bb2edcbe390.png";